(function() { window.GUID_aaf6778f_90ac_4d0a_9bb2_58210efdc363 = { getGuid: function() { return "aaf6778f-90ac-4d0a-9bb2-58210efdc363"; } }; })();
var BergerSchedule;
(function (BergerSchedule) {
    var treeViewDivisions;
    CompuSport.on('allscriptsloaded', function () {
        BindElements();
    });
    function BindElements() {
        treeViewDivisions = $('#TreeViewDivisions').control();
        if (treeViewDivisions == null) {
            return;
        }
        let mainContainerRefreshedPart = $('#MainContainerRefreshedPart');
        let btnEmbedBergerSchedule = $('#BtnEmbedBergerSchedule');
        let btnLinkFullScreen = $('#BtnLinkFullScreen');
        let btnGetHtml = $('#BtnGetHtml');
        let btnPrintBerger = $('#BtnPrintBerger');
        if (treeViewDivisions.SelectedValue() != null) {
            let data = {
                flowBlockId: treeViewDivisions.SelectedValue()
            };
            ShowHideButton(true, data);
        }
        treeViewDivisions.TreeViewItemSelected = function (treeViewItem) {
            treeViewDivisions.CloseDropDown();
            if (treeViewItem.data('values') != null) {
                let data = {
                    flowBlockId: treeViewItem.data('values')[0]
                };
                ShowHideButton(true, data);
            }
            else {
                ShowHideButton(false, null);
            }
        };
        btnEmbedBergerSchedule.on('click', 'a', function (e) {
            e.preventDefault();
            ShowEmbeddedPopupInfo(false);
        });
        btnLinkFullScreen.on('click', 'a', function (e) {
            e.preventDefault();
            ShowEmbeddedPopupInfo(true);
        });
        btnPrintBerger.on('click', 'a', function (e) {
            e.preventDefault();
            let reportParam = "?ReportName=LeagueScheduleBerger" +
                "&SelectedFlowBlockId=" + treeViewDivisions.SelectedValue();
            reportParam = reportParam + "&ShowReportViewer=false";
            window.open(CSParameters.RUrl + "Printing/Print/" + CSParameters.SportEventId + reportParam);
        });
        btnGetHtml.on('click', 'a', function (e) {
            e.preventDefault();
            window.location.href = CSParameters.BaseUrl + 'Schedules/GetBergerScheduleHtml/' + CSParameters.SportEventId + "?flowBlockId=" + treeViewDivisions.SelectedValue();
        });
        function ShowHideButton(divisionSelected, data) {
            if (divisionSelected) {
                btnEmbedBergerSchedule.removeClass('IsDisabled');
                btnLinkFullScreen.removeClass('IsDisabled');
                btnGetHtml.removeClass('IsDisabled');
                btnPrintBerger.removeClass('IsDisabled');
                CompuSport.Ajax.Get(CSParameters.RUrl + "Schedules/RefreshBergerSchedule/" + CSParameters.SportEventId, data, function (response) {
                    $('#MainContainerRefreshedPart')[0].innerHTML = response;
                });
            }
            else {
                mainContainerRefreshedPart.empty();
                btnEmbedBergerSchedule.addClass('IsDisabled');
                btnLinkFullScreen.addClass('IsDisabled');
                btnGetHtml.addClass('IsDisabled');
                btnPrintBerger.addClass('IsDisabled');
            }
        }
        function ShowEmbeddedPopupInfo(justHyperlink) {
            let data = {
                flowBlockId: treeViewDivisions.SelectedValue(),
                justHyperlink: justHyperlink
            };
            CompuSport.Ajax.Get(CSParameters.BaseUrl + "Schedules/GetBergerScheduleEmbbededString/" + CSParameters.SportEventId, data, function (result) {
                CompuSport.Controls.Popup.ShowWarningDialog(result);
            });
        }
    }
    BergerSchedule.BindElements = BindElements;
})(BergerSchedule || (BergerSchedule = {}));

//# sourceMappingURL=BergerSchedule.js.map
